import { render, staticRenderFns } from "./NewComposerDrafts.vue?vue&type=template&id=9f5c6818&"
import script from "./NewComposerDrafts.vue?vue&type=script&lang=js&"
export * from "./NewComposerDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports